export default "__VITE_PUBLIC_ASSET__b42ab2a4__"